const toDateKey = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString().slice(0, 10);
};

export const getPlanningTask = (wo) => {
  if (!wo || wo.status === 'CANCELLED') return null;

  const titleTrimmed = String(wo.title || '').trim();
  const inPlanningPipeline =
    Boolean(wo.camoQmAcknowledged) || Boolean(wo.planningApproved);
  if (!titleTrimmed && inPlanningPipeline) {
    return {
      type: 'TITLE_REQUIRED',
      label: 'Work Order Title Required',
      color: 'error'
    };
  }

  // Awaiting first planning decision (or Create WO from client request).
  if (wo.camoQmAcknowledged && !wo.planningApproved && !wo.planningRejectedAt) {
    if (wo.jobSource === 'EXTERNAL_PORTAL') {
      return {
        type: 'CREATE_WORK_ORDER',
        label: 'Create Work Order (client request)',
        color: 'warning'
      };
    }
    return {
      type: 'PLANNING_APPROVAL_REQUIRED',
      label: 'Planning Approval Required',
      color: 'warning'
    };
  }

  // Post-approval actionable tasks must be checked before the "Approved" fallback;
  // otherwise Reschedule / Rework / Procurement never surface on Planning Tasks.
  if (wo.planningApproved && !wo.planningRejectedAt) {
    if (wo.needsStoreAction && wo.storeRejectedAt && !wo.storeAccepted && wo.storeAvailabilityDate) {
      const scheduledDateKey = toDateKey(wo.scheduledDate);
      const storeAvailabilityDateKey = toDateKey(wo.storeAvailabilityDate);
      if (!scheduledDateKey || scheduledDateKey <= storeAvailabilityDateKey) {
        return {
          type: 'PLANNING_RESCHEDULE_AFTER_STORE',
          label: 'Reschedule After Store Date',
          color: 'warning'
        };
      }
    }

    if (wo.needsMROAction && wo.mroRejectedAt && !wo.mroAccepted) {
      return {
        type: 'PLANNING_REWORK_AFTER_MRO',
        label: 'Planning Rework After MRO',
        color: 'warning'
      };
    }

    if (wo.needsStoreAction && !wo.linkedWorkOrderId && !wo.isPartsProcurementWO) {
      const hasRequirements = Array.isArray(wo.partsProcurementRequirements?.partNumbers) &&
        wo.partsProcurementRequirements.partNumbers.length > 0;
      if (!hasRequirements) {
        return {
          type: 'PROCUREMENT_REQUIREMENTS_REQUIRED',
          label: 'Procurement Requirements Required',
          color: 'info'
        };
      }
    }

    return {
      type: 'PLANNING_APPROVED',
      label: 'Planning Approved',
      color: 'success'
    };
  }

  return null;
};

export const isPendingPlanningTask = (wo) => {
  const taskType = wo?.planningTask?.type;
  return Boolean(taskType) && taskType !== 'PLANNING_APPROVED';
};

export const attachPlanningTask = (wo) => ({
  ...wo,
  planningTask: getPlanningTask(wo)
});
